import { UploadedFile } from 'src/data-capture/hooks/file-uploads/types';
import { isAudioFile } from '../allowedFileTypes';
import { Action } from './FilesTable';

type FiledDocumentRowHandlers = {
  onPlay: (file: UploadedFile) => void;
  onRenameFolder: (file: UploadedFile) => void;
  onMove: (file: UploadedFile) => void;
  onDelete: (file: UploadedFile) => void;
  onSelect: (file: UploadedFile) => void;
};

export function buildFiledDocumentRowActions(
  file: UploadedFile,
  { onPlay, onRenameFolder, onMove, onDelete, onSelect }: FiledDocumentRowHandlers,
): Action<UploadedFile>[] {
  const select = { label: 'Select', action: onSelect };
  const move = { label: 'Move', action: onMove };
  const deleteAction = { label: 'Delete', action: onDelete, color: 'red' };

  if (file.isFolder) {
    return [{ label: 'Rename', action: onRenameFolder }, move, deleteAction];
  }

  if (isAudioFile(file.file.fileType, file.file.fileName)) {
    return [{ label: 'Play', action: onPlay }, select, move, deleteAction];
  }

  return [select, move, deleteAction];
}
